/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Rejection_Reason_PlaceholderInputs */

const en_samples_rejection_reason_placeholder = /** @type {(inputs: Samples_Rejection_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a rejection reason...`)
};

const es_samples_rejection_reason_placeholder = /** @type {(inputs: Samples_Rejection_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar una razon de rechazo...`)
};

/**
* | output |
* | --- |
* | "Add a rejection reason..." |
*
* @param {Samples_Rejection_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_rejection_reason_placeholder = /** @type {((inputs?: Samples_Rejection_Reason_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Rejection_Reason_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_rejection_reason_placeholder(inputs)
	return es_samples_rejection_reason_placeholder(inputs)
});